import { useEffect } from "react";

/**
 * Listens for the Escape key and calls the handler when pressed.
 * Useful for closing modals, dropdowns, or other overlays.
 *
 * @param handler - Callback to execute when Escape is pressed
 */
export function useEscapeKey(handler: () => void) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") handler();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handler]);
}
